import React from 'react';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-[#03ADED] to-[#0288D1] text-white py-20 px-4" id='inicio'>
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
        <div className="md:w-1/2 space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
            Software peruano para negocios peruanos
          </h1>
          <p className="text-xl text-[#B3E5FC]">
            Soluciones a medida para inventarios, barberías, restaurantes y más. 
            Simple, poderoso y hecho para crecer contigo.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="https://wa.me/51972843376?text=Hola%20YupiSoft,%20quiero%20agendar%20una%20cita" className="bg-white text-[#03ADED]  font-bold py-3 px-8 rounded-lg transition-all transform hover:scale-105">
              Agendar cita
            </a>
            <a href="https://wa.me/51972843376?text=Hola%20YupiSoft,%20quiero%20mas%20información%20sobre" className="bg-transparent border-2 border-white hover:bg-white/10 font-bold py-3 px-8 rounded-lg transition-all transform hover:scale-105">
              WhatsApp +51 972 843 376
            </a>
          </div>
        </div>
        <div className="md:w-1/2">
          <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl border border-white/20">
            <div className="aspect-video bg-white/20 rounded-lg flex items-center justify-center">
              
              <img src="/4.png" alt="Demo Interactiva" className="absolute inset-0 w-full h-full object-cover rounded-lg p-6" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;